const DTODBA21 = {
  ORCA: "/api/DTODBA21/ORCA/verify",
  insert: "/api/DTODBA21/insert",
  update: "/api/DTODBA21/update",
  login: "/api/DTODBA21/login",
  getOTP: "/api/DTODBA21/getOTP",
  chkOTP: "/api/DTODBA21/chkOTP",
  getLoginUserInfo: "/api/DTODBA21/getLoginUserInfo",
  queryByCondition: "/api/DTODBA21/queryByCondition",
  readAllUserDatail: "/api/DTODBA21/readAllUserDatail",
  setUserKeyInVal: "/api/DTODBA21/setUserKeyInVal",
  getUserKeyInVal: "/api/DTODBA21/getUserKeyInVal",
  getCaptcha: "/api/DTODBA21/getCaptcha",
  getCheckKey: "/api/DTODBA21/getCheckKey",
  getTokenByPlatform: "/api/DTODBA21/getTokenByPlatform",
  convertPartyNo: "/api/DTODBA21/convertPartyNo",
  logout: "/api/DTODBA21/logout",
  countByNoRepeatIdDuringTm: "/api/DTODBA21/countByNoRepeatIdDuringTm",
  checkUserAvailable: "/api/DTODBA21/checkUserAvailable",
  updateUserByManagers: "/api/DTODBA21/updateUserByManagers"
};

export default DTODBA21;
